import { useMutation } from '@tanstack/react-query';
import { updateNetworkingConfigurationAppQuery } from '../apis';
import { toast } from 'react-toastify';

const useUpdateNetworkingConfiguration = () => {
  const mutationData = useMutation({
    mutationFn: updateNetworkingConfigurationAppQuery,
    onSuccess: (response) => {
      const message = response?.data?.Message || 'Network configuration updated successfully';
      toast.success(message);
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error updating network configuration:', error);
    },
  });

  return mutationData;
};

export default useUpdateNetworkingConfiguration;
